// extracted by mini-css-extract-plugin
export default {"AssigneeAvatar":"Assignee-module__AssigneeAvatar--ATit0"};